import { render, staticRenderFns } from "./shopVipUserAccount.vue?vue&type=template&id=5c5463b7&scoped=true"
import script from "./shopVipUserAccount.vue?vue&type=script&lang=js"
export * from "./shopVipUserAccount.vue?vue&type=script&lang=js"
import style0 from "./shopVipUserAccount.vue?vue&type=style&index=0&id=5c5463b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5463b7",
  null
  
)

export default component.exports